module.exports = __webpack_public_path__ + "img/20.577667b3.png";